import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import BulletList from 'components/BulletList';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import Heading from 'components/Heading';
import Stack from 'components/Stack';
import { MenuTextButton } from 'components/Menu';
export var dateOptions = {
  month: 'numeric',
  year: 'numeric',
  day: 'numeric'
};
function ListPopup(_ref) {
  var onClose = _ref.onClose,
    titleKey = _ref.titleKey,
    listItems = _ref.listItems,
    _ref$listLayout = _ref.listLayout,
    listLayout = _ref$listLayout === void 0 ? 'list' : _ref$listLayout;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isStack = listLayout === 'stack';
  return /*#__PURE__*/React.createElement(Box, {
    role: "dialog",
    "aria-labelledby": titleKey,
    px: "m",
    py: "s"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h1",
    size: "extra-small",
    id: titleKey,
    mb: "xs",
    mr: "l"
  }, t(titleKey)), /*#__PURE__*/React.createElement(Button, {
    icon: "x",
    variant: "transparent",
    title: t('actions_close_modal'),
    onClick: onClose,
    position: "absolute",
    right: "xxs",
    top: "xxs"
  }), /*#__PURE__*/React.createElement(Box, {
    fontSize: "s"
  }, isStack ? /*#__PURE__*/React.createElement(Stack, {
    withDividers: true,
    spacing: "xs"
  }, listItems) : /*#__PURE__*/React.createElement(BulletList, null, listItems)));
}
function DetailsDropdown(_ref2) {
  var listItems = _ref2.listItems,
    children = _ref2.children,
    isDisabled = _ref2.isDisabled,
    titleKey = _ref2.titleKey,
    listLayout = _ref2.listLayout;
  return /*#__PURE__*/React.createElement(Dropdown, {
    placement: "bottom-end",
    renderInPlace: true,
    allowTooltipClicks: true,
    content: function content(dropdown) {
      return /*#__PURE__*/React.createElement(ListPopup, {
        listItems: listItems,
        onClose: dropdown.close,
        listLayout: listLayout,
        titleKey: titleKey
      });
    }
  }, function (dropdown) {
    return /*#__PURE__*/React.createElement(MenuTextButton, {
      ref: dropdown.ref,
      onClick: dropdown.toggle,
      "aria-expanded": dropdown.isOpen ? 'true' : 'false',
      isDisabled: isDisabled
    }, children);
  });
}
export default DetailsDropdown;